function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import commonMsgs from '../../nls/common.properties';
import messages from '../../nls/setup/deploy/deploy.properties';
import MissingSchemaErrorDetails from './errors/missing-schema-error-details.jsx';
import { Modal } from '@carbon/react';
import React from 'react';
import TemplateError from './errors/template-error.jsx';
import '../../scss/setup/deploy/_error-section.scss';
Object.assign = Object.assign || require('object-assign');
var ErrorWidget = /*#__PURE__*/function (_React$Component) {
  function ErrorWidget() {
    _classCallCheck(this, ErrorWidget);
    return _callSuper(this, ErrorWidget, arguments);
  }
  _inherits(ErrorWidget, _React$Component);
  return _createClass(ErrorWidget, [{
    key: "renderSpecical",
    value: function renderSpecical(err) {
      switch (err.code) {
        case "noschema":
          return /*#__PURE__*/React.createElement(MissingSchemaErrorDetails, {
            error: err
          });
        case "502":
          return /*#__PURE__*/React.createElement(Err502, {
            error: err
          });
      }

      // Some errors carry more info in a details property
      if (err.details) {
        var details = err.details;
        switch (details.code) {
          case "INVALID_TEMPLATE":
            return /*#__PURE__*/React.createElement(TemplateError, {
              error: err
            });
        }
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.props.error;
      var description = "";
      if (error.details && error.details.description) {
        description = error.details.description;
      }
      var result = /*#__PURE__*/React.createElement(Modal, {
        className: "error-section",
        open: true,
        modalHeading: error.title || messages.get("error.generic"),
        primaryButtonText: commonMsgs.get('close'),
        onRequestClose: this.props.onModalClose,
        onRequestSubmit: this.props.onModalClose
      }, /*#__PURE__*/React.createElement("div", {
        className: "subtitle"
      }, error.description || error.message || error), description !== "" ? /*#__PURE__*/React.createElement("div", {
        className: "subtitle"
      }, description) : null, this.renderSpecical(error));
      return result;
    }
  }]);
}(React.Component);
export { ErrorWidget as default };
var Err502 = /*#__PURE__*/function (_React$Component2) {
  function Err502() {
    _classCallCheck(this, Err502);
    return _callSuper(this, Err502, arguments);
  }
  _inherits(Err502, _React$Component2);
  return _createClass(Err502, [{
    key: "render",
    value: function render() {
      var error = this.props.error;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "subtitle details"
      }, error.details, " ", error.txId ? "(" + error.txId + ")" : ""), /*#__PURE__*/React.createElement("div", {
        className: "subtitle"
      }, messages.get("error.temporaryProblem")));
    }
  }]);
}(React.Component);